import React, { Component } from 'react';
import { addTitle } from "../../../utils/DynamicTitle";

class About extends Component {
    componentDidMount() {
        addTitle("Blife");

    }
    render() {
        return (
            <div>
                <div className="features-section">
                    <div className="container-sm">
                        <div className="column-img">
                            <img src="assets/images/img-features.png" title="" alt="" />
                        </div>
                        <div className="column-text">
                            <h2>About Us</h2>
                            {/*<h3>BLife (Bright LifeCare Pvt. Ltd.) is committed to the mission of creating world class*/}
                            {/*health and wellness brands for consumer worldwide.</h3>*/}
                            <p>Bright Lifecare Pvt Ltd (blife.in) is engaged in the business of manufacturing, R&D, marketing, & sale of health/sports supplements, vitamins and other health/ wellness products across India. The company has a wide reputation and goodwill in the market as a leading company in the space. Via "HealthKart" it also offers a comprehensive range of products, through both online and offline channels.</p>
                        </div>
                    </div>
                </div>

                <div className="journey-section">
                    <div className="container-sm">
                        <div className="row">
                            <div className="column-text">
                                <h2>Our Journey so far…</h2>
                                <p>Committed to the mission of creating world class health and wellness products</p>
                            </div>
                            <div className="column-img">
                                <img src="assets/images/img-journey.png" title="" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="timeline-section">
                    <div className="container-sm">
                        <div className="timeline_body">
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2011</span>
                                    </div>
                                    <p>India got its one-stop-shop for wellness, nutrition and health products, with the launch of HealthKart.com</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2012</span>
                                    </div>
                                    <p>For all the ‘ziddi’ fitness enthusiasts, HealthKart launched Muscleblaze - India’s best bodybuilding and sports nutrition supplements brand.</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2013</span>
                                    </div>
                                    <p>HealthKart took off on its retail journey with its first store launch in India.</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2014</span>
                                    </div>
                                    <p>Healthkart moves towards being a fitness destination and invests in digital
                                        platforms</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2015</span>
                                    </div>
                                    {/* <p>Launch of discovery and consultation services</p> */}
                                    <p>MuscleBlaze crosses 200K customers</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2016</span>
                                    </div>
                                    {/* <p>After mastering online and offline stores, it was time to go personal with the launch of HK Consult - discovery and consultation services.</p> */}
                                    <p>HealthKart Private Label was also launched to up the wellness and health quotient.</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2017</span>
                                    </div>
                                    <p>An in-house Research and Development facility was set up to innovate and introduce new products while maintaining the highest quality and standards.</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2018</span>
                                    </div>
                                    <p>Set up dedicated R&D Facility</p>
                                    <p>Scaled up to 105 stores across 37 cities</p>
                                    <p>Received Amazon Aces Award for MuscleBlaze</p>
                                    {/* <p>Launched Nouriza – A Nutrition Snacking brand</p> */}
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2019</span>
                                    </div>
                                    <p>TrueBasics was launched to ensure top-of-the-line health products so that you never have to compromise on basic health.</p>
                                    <p>Gritzo was launched to provide a customized range of nutritional products for children.</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2020</span>
                                    </div>
                                    <p>HK addressed the current trends and came up with bGREEN - a Vegan and plant-based nutrition brand.</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2021</span>
                                    </div>
                                    <p>HealthKart’s private label for vitamins transitioned to HK Vitals for all your vital needs while Muscleblaze became the number one sports nutrition brand in India.</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2022</span>
                                    </div>
                                    <p>{`HealthKart raises $135 million`}</p>
                                </div>
                            </div>
                            <div className="timeline_row">
                                <div className="timeline_box">
                                    <div className="timeline_line">
                                        <span>2023</span>
                                    </div>
                                    <p>{`Launched MB in singapore, UAE`}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="profile-section">
                    <div className="container-sm">
                        <div className="row justify-content-between">
                            <div className="column-text leftCell">
                                <h2>Sameer Maheshwari</h2>
                                <h3>Founder & CEO</h3>
                                <p>A graduate from the prestigious Harvard Business School and a Bachelor of Technology from IIT Delhi, Sameer always held health with the highest regard. After working for 12 years in financial services and technology industries in the US, including UBS Investment Bank, MicroStrategy and Deloitte Consulting, he gave in to his true calling and founded HealthKart in 2011. His vision is to make HealthKart, a one-stop-shop and go-to health and nutrition destination that can help people achieve their fitness goals, be it muscle building, weight loss, general immunity, or holistic wellness.</p>
                                <p className="text-drak">
                                    <a href="https://www.linkedin.com/in/sameer-maheshwari-7a8a78/" target='_blank' rel="noopener noreferrer" >
                                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                                    </a>

                                </p>
                            </div>
                            <div className="column-img rightCell">
                                {/* <img src="assets/images/sameer-maheshwari_v2.png" title="" alt=""/> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;
